function guidString(hyphenate: boolean): string {
  const guidBlock = (Math.random().toString(16) + '000000000').substr(2, 8);
  return hyphenate ? '-' + guidBlock.substr(0, 4) + '-' + guidBlock.substr(4, 4) : guidBlock;
}

export function generateGuid(): string {
  return guidString(false) + guidString(true) + guidString(true) + guidString(false);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/helper/guid/index.ts